<section class="px-4 websites_managment">
  <div class="d-flex justify-content-between align-items-center">
    <div class="page_header d-flex">
      <button class="back_icon me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h1 translate class="m-0 page_header_title">Testimonials</h1>
    </div>
    <div class="mv-header-container">
      <button
        translate
        mat-raised-button
        color="primary"
        (click)="openUploadDialog()"
        class="px-5 add_button"
      >
       + Add Testimonials
      </button>
    </div>
  </div>
  <div class="table-container list-container mt-3 p-0">
    <div
      *ngIf="testimonialsData?.length === 0"
      class="empty-data list-container d-flex flex-column justify-content-center align-items-center"
    >
      <i class="fa-solid fa-inbox empty-icon"></i>
      <p translate>No Data found</p>
    </div>
    <table
      mat-table
      [dataSource]="testimonialsData"
      *ngIf="testimonialsData?.length"
    >
      <ng-container matColumnDef="uploadDate">
        <th translate mat-header-cell *matHeaderCellDef>Upload Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.created_at | date: "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th translate mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element" class="client-name">
          {{ element.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th translate mat-header-cell *matHeaderCellDef>Description</th>
        <td
          mat-cell
          *matCellDef="let element"
          class="cursor_pointer description-text"
          [matTooltip]="element.description"
          matTooltipPosition="right"
          #tooltip="matTooltip"
          (click)="tooltip.toggle()"
        >
          {{ element.description | slice: 0 : 50
          }}{{ element.description.length > 50 ? "..." : "" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="images">
        <th translate mat-header-cell *matHeaderCellDef>Video</th>
        <td mat-cell *matCellDef="let element">
          <div
            class="video-thumb-container cursor_pointer"
            (click)="viewItem(element)"
          >
            <video
              [src]="this.imagePath + '/' + element.media_url"
              class="notice-image"
              muted
              preload="metadata"
            ></video>
            <div class="play-overlay">
              <i class="fa-solid fa-play"></i>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th translate mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex justify-content-evenly align-items-center">
            <p translate (click)="viewItem(element)" class="m-0 cursor_pointer">
              View
            </p>
            <p
              mat-icon-button
              [matMenuTriggerFor]="menu"
              class="m-0 cursor_pointer"
            >
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </p>
          </div>
          <mat-menu #menu="matMenu" class="themed-menu">
            <button mat-menu-item (click)="editItem(element)">
              <mat-icon>edit</mat-icon>
              <span translate>Edit</span>
            </button>
            <button mat-menu-item (click)="deleteItem(element.id)">
              <mat-icon class="text-danger">delete</mat-icon>
              <span translate class="text-danger">Delete</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="hover-row"
      ></tr>
    </table>
  </div>
</section>
